import React from "react";
import {
  SideBarInternalList,
  SideBarInternal,
  UserNameWrapper,
  NameContainer,
  EmailContainer,
} from "./style";
import HelpComponent from "./HelpComponent/HelpComponent";
import RowContainer from "../../common/RowContainer";
import {
  ArrowRightRounded,
  CloseRounded,
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded,
} from "@mui/icons-material";
import { FormattedMessage } from "react-intl";
import { FormatDateTime } from "../../../utils/helpers/FormatDateTime";

export default function InternalSideBar({ userProfileData, onOpenDrawer }) {
  const now = new Date();
  const handleCloseDrawer = () => {
    onOpenDrawer(false);
  };

  return (
    <SideBarInternal>
      <RowContainer end>
        <CloseRounded
          fontSize="small"
          onClick={handleCloseDrawer}
          sx={{ cursor: "pointer" }}
        />
      </RowContainer>
      <UserNameWrapper>
        <NameContainer>
          <FormattedMessage id="dashboard.internalSidebar.welcome"></FormattedMessage>
          , {userProfileData?.first_name}!
        </NameContainer>
        <EmailContainer>{<FormatDateTime value={now} />}</EmailContainer>
      </UserNameWrapper>
      {/* SCARICA LA GUIDA */}
      {/* <SideBarInternalList>
        <HelpComponent />
      </SideBarInternalList> */}
    </SideBarInternal>
  );
}
